import React from 'react';
import ReactDOM from 'react-dom';

import iconSearch from '../assets/svg/icon-search.svg';
import iconClose from '../assets/svg/icon-cross.svg';

import {Cart, Search, Modal} from './components';

const App = () => {
  if (window.theme.ecommerce) {
    const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '';
    const freeShippingBarSettings = {
      enabled: window.theme.freeShippingBar && window.theme.freeShippingBar.enabled,
      remainingTemplate: window.theme.strings.freeShippingBar.remaining,
      reachedTemplate: window.theme.strings.freeShippingBar.reached,
      serviceOne: window.theme.freeShippingBar.serviceOne,
      serviceTwo:
        window.theme.freeShippingBar && window.theme.freeShippingBar.serviceTwo
          ? window.theme.freeShippingBar.serviceTwo
          : null,
      thresholdOne: Number(window.theme.freeShippingBar.thresholdOne) * 100,
      thresholdTwo:
        window.theme.freeShippingBar && window.theme.freeShippingBar.thresholdTwo
          ? Number(window.theme.freeShippingBar.thresholdTwo) * 100
          : null,
    };
    const cartMessage = {
      enabled: window.theme.cartMessage?.enabled,
      customMessage:
        window.theme.cartMessage && window.theme.cartMessage.customMessage
          ? window.theme.cartMessage.customMessage
          : null,
    };

    const cartWrapper = document.querySelector('#react-side-cart');
    if (cartWrapper) {
      ReactDOM.render(
        <Cart
          rootUrl={rootUrl}
          freeShippingBarSettings={freeShippingBarSettings}
          isCartPage={false}
          cartMessage={cartMessage}
        />,
        cartWrapper
      );
    }

    const cartPageWrapper = document.querySelector('#react-cart-page');
    if (cartPageWrapper && window.theme.locale.pageType === 'cart') {
      ReactDOM.render(
        <Cart
          rootUrl={rootUrl}
          freeShippingBarSettings={freeShippingBarSettings}
          isCartPage
          cartMessage={cartMessage}
        />,
        cartPageWrapper
      );
    }
  }

  const headerSearchEl = document.querySelector('#react-search-modal');
  if (headerSearchEl && window.theme.searchSettings.enableInstantSearch) {
    ReactDOM.render(
      <Modal
        size="full-screen"
        triggerLabel={
          <>
            <span
              className="search-modal__trigger-icon"
              dangerouslySetInnerHTML={{__html: `${iconSearch} ${iconClose}`}}
            />
            <span className="hide--max-lg">{window.theme.strings.search.search}</span>
          </>
        }
        closeLabel={window.theme.strings.search.close}
        triggerClassName="search-modal__trigger nav-secondary__link btn-none"
        container={document.querySelector('.header-section') ?? document.body}
        toggleClass="search"
        toggleEvent="toggleSearch"
        modalClassName="modal--search modal--drawer modal--drawer-right"
      >
        <Search
          placeholder={window.theme.strings.search.placeholder}
          rootUrl={window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl}
          resources={{
            type: window.theme.searchSettings.types.join(','),
            limit: window.theme.searchSettings.limit,
          }}
          unavailableProducts={window.theme.searchSettings.unavailable_products}
          fields={window.theme.searchSettings.fields}
          enableInstantSearch={window.theme.searchSettings.enableInstantSearch}
          showSearchSuggestions={window.theme.searchSettings.showSearchSuggestions}
          instantNoResults={window.theme.strings.search.instantNoResults}
          searchSuggestionsTitle={window.theme.strings.search.topSearches}
          searchSuggestions={window.theme.searchSettings.searchSuggestions}
          resultMoneyFormat={window.theme.moneyFormat}
          clearIcon={
            <>
              <span dangerouslySetInnerHTML={{__html: iconClose}} />
            </>
          }
          typeProductsTitle={window.theme.strings.search.typeProducts}
          typeArticlesTitle={window.theme.strings.search.typeArticles}
          viewAllString={window.theme.strings.search.viewAll}
        />
      </Modal>,
      headerSearchEl
    );
  }
};

export default App;
